import { addUnitMembers, deleteUnitMember, getUnitMembers, registerUnitMember } from "../../../api/unit/members";
import { Button } from "../../Button";
import { ConfirmationModal } from "../../ConfirmationModal";
import { default as convertStringToColor } from "../../../helpers/util/convertStringToColor";
import { getAvailableUnitMembers } from "../../../api/unit/members";
import { MemberCard } from ".";
import { PropTypes } from "prop-types";
import { QueryLoader } from "../../Loader";
import { Search } from "../../Search";
import { Select } from "../../Select";
import { SelectableMultiplePeople } from "../../SelectableLists/SelectablePeople";
import { StyledField } from "../../../styles/StyledField";
import { StyledModal, StyledPeopleModal } from "../../../styles/StyledModal";
import { StyledUnitMembersContainer, StyledUnitMembersHeader, StyledUnitMembersList } from "../../../styles/StyledUnit/StyledContent";
import { useAppContext } from "../../../context/appContext";
import { useEffect, useState } from "react";
import { useQuery } from "react-query";
import AddIcon from "../../../assets/img/icons/add.svg";
import CloseIcon from "../../../assets/img/icons/close.svg";
import Modal from "react-modal";
import ModalHeader from "../../ModalHeader/ModalHeader";
import SaveIcon from "../../../assets/img/icons/save.svg";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";

export default function UnitMembers({ id }) {
	const { items } = useAppContext();
	const { axiosPrivate } = useAxiosPrivate();

	const [openDropdowns, setOpenDropdowns] = useState({});
	const [modalIsOpen, setModalIsOpen] = useState(false);
	const [addModalIsOpen, setAddModalIsOpen] = useState(false);
	const [deletedId, setDeletedId] = useState(null);
	const [roleValue, setRoleValue] = useState(null);
	const [phrase, setPhrase] = useState(null);
	const { isLoading, isError, error, data, refetch } = useQuery(["membersTab", id, phrase], () => getUnitMembers(axiosPrivate, id, phrase));
	const [result, setResult] = useState([]);

	const [choosenPeople, setChoosenPeople] = useState({});

	//Add member form
	const [firstName, setFirstName] = useState("");
	const [lastName, setLastName] = useState("");
	const [userName, setUserName] = useState("");
	const [displayForm, setDisplayForm] = useState(false);

	useEffect(() => {
		if (!isLoading && !isError) {
			setResult(roleValue ? data.filter((e) => e.roles.includes(roleValue)) : data);
			for (const member of data) {
				setOpenDropdowns({ ...openDropdowns, [`p${member.id}`]: false });
			}
		}
	}, [isLoading, roleValue, data]);

	const handleDelete = async (userId) => {
		await deleteUnitMember(axiosPrivate, refetch, id, userId);
	};

	if (isError) {
		console.log(error);
		refetch();
	}

	const handleRegister = async () => {
		// setDisplayForm(false);
		setAddModalIsOpen(false);
		await registerUnitMember(axiosPrivate, refetch, id, { username: userName, firstName: firstName, lastName: lastName });
	};

	const handlePost = async () => {
		const users = [];
		for (const key in choosenPeople) {
			if (choosenPeople[key]) users.push(parseInt(choosenPeople[key].id));
		}
		// setDisplayForm(false);
		setAddModalIsOpen(false);
		await addUnitMembers(axiosPrivate, refetch, id, { roles: ["decision-maker"], users: [...users] });
	};

	return (
		<>
			<StyledUnitMembersContainer>
				<StyledUnitMembersHeader>
					<StyledField mb="12px" edit>
						<label>Role</label>
						<Select
							options={[
								{ value: null, label: "All" },
								{ value: "owner", label: "Unit Owner" },
								{ value: "decision-maker", label: "Decision Maker" },
							]}
							value={roleValue}
							setMatterId={setRoleValue}
							id="role"
							name="role"
							data-testid="role"
							isBig
						/>
					</StyledField>
					<Search isWhite setPhrase={setPhrase} />
				</StyledUnitMembersHeader>
				{isLoading && <QueryLoader />}
				<StyledUnitMembersList>
					{!isLoading &&
						!isError &&
						(result.length > 0 ? (
							result.map((e, i) => (
								<MemberCard
									key={i}
									data={e}
									color={convertStringToColor(e.user.firstName + e.user.lastName)}
									openDropdowns={openDropdowns}
									setOpenDropdowns={setOpenDropdowns}
									direction={"left"}
									moreActionsPosition={"absolute"}
									openModal={(id) => {
										setDeletedId(id);
										setModalIsOpen(true);
									}}
									refetch={refetch}
									showOptions={items.userUnits[id] !== undefined && items.userUnits[id].includes("owner")}
								/>
							))
						) : (
							<h6>No members found</h6>
						))}
				</StyledUnitMembersList>
				{items.userUnits[id] !== undefined && items.userUnits[id].includes("owner") && (
					<Button
						icon={AddIcon}
						onClick={() => {
							setAddModalIsOpen(true);
						}}
					>
						Add member
					</Button>
				)}
			</StyledUnitMembersContainer>
			<Modal
				isOpen={modalIsOpen}
				onRequestClose={() => setModalIsOpen(false)}
				style={StyledModal}
				appElement={document.getElementById("app")}
			>
				<ConfirmationModal handleDelete={handleDelete} deletedId={deletedId} closeModal={() => setModalIsOpen(false)} />
			</Modal>
			<Modal
				isOpen={addModalIsOpen}
				onRequestClose={() => setAddModalIsOpen(false)}
				style={StyledPeopleModal}
				appElement={document.getElementById("app")}
			>
				<ModalHeader
					onClick={() => {
						setAddModalIsOpen(false);
					}}
				>
					Add Unit Member
				</ModalHeader>
				<SelectableMultiplePeople
					id={id}
					refetch={refetch}
					choosenPeople={choosenPeople}
					setChoosenPeople={setChoosenPeople}
					fetchPeople={getAvailableUnitMembers}
				>
					{displayForm && (
						<>
							<div className="form">
								<StyledField mb="12px" edit>
									<label>First name</label>
									<input
										type="text"
										name="firstName"
										className="firstName"
										value={firstName}
										onChange={(e) => setFirstName(e.target.value)}
									/>
								</StyledField>
								<StyledField mb="12px" edit>
									<label>Last name</label>
									<input type="text" name="lastName" className="lastName" value={lastName} onChange={(e) => setLastName(e.target.value)} />
								</StyledField>
								<StyledField mb="12px" edit>
									<label>Username</label>
									<input type="text" name="userName" className="userName" value={userName} onChange={(e) => setUserName(e.target.value)} />
								</StyledField>
							</div>
							<div className="form-buttons">
								<img
									onClick={() => {
										handleRegister();
										setDisplayForm(false);
									}}
									src={SaveIcon}
									alt={SaveIcon}
									role="img"
								/>
								<img
									onClick={() => {
										setDisplayForm(false);
									}}
									src={CloseIcon}
									alt={CloseIcon}
									role="img"
								/>
							</div>
						</>
					)}
					<div className="action-buttons">
						<Button icon={AddIcon} onClick={() => setDisplayForm(true)}>
							ADD NEW USER
						</Button>
						<Button
							onClick={() => {
								setAddModalIsOpen(false);
							}}
							bg={false}
							small={true}
						>
							cancel
						</Button>
						<Button
							icon={AddIcon}
							onClick={() => {
								handlePost();
								setDisplayForm(false);
							}}
						>
							ADD UNIT MEMBER
						</Button>
					</div>
				</SelectableMultiplePeople>
			</Modal>
		</>
	);
}

UnitMembers.propTypes = {
	id: PropTypes.string,
};
